import auth, { IChangeProfile } from '../services/auth';

export default async (formData: IChangeProfile) => {
    return await auth.changeProfile(formData);
};
